"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var rules_service_1 = require("./rules/rules.service");
var rules_model_1 = require("./rules/models/rules.model");
exports.Rules = rules_model_1.Rules;
var traveler_detail_config_model_1 = require("./rules/models/traveler-detail-config.model");
exports.TravelerDetailConfig = traveler_detail_config_model_1.TravelerDetailConfig;
var policy_config_model_1 = require("./rules/models/policy-config.model");
exports.PolicyConfig = policy_config_model_1.PolicyConfig;
var field_rules_model_1 = require("./rules/models/field-rules.model");
exports.FieldRules = field_rules_model_1.FieldRules;
var rules_service_2 = require("./rules/rules.service");
exports.BhtpRulesService = rules_service_2.BhtpRulesService;
var constraint_rules_model_1 = require("./rules/models/constraint-rules.model");
exports.ConstraintRules = constraint_rules_model_1.ConstraintRules;
var min_max_constraint_model_1 = require("./rules/models/min-max-constraint.model");
exports.MinMaxConstraint = min_max_constraint_model_1.MinMaxConstraint;
var select_item_model_1 = require("./rules/models/select-item.model");
exports.SelectItem = select_item_model_1.SelectItem;
function bhtpRulesServiceFactory(http) {
    return new rules_service_1.BhtpRulesService(http);
}
exports.bhtpRulesServiceFactory = bhtpRulesServiceFactory;
/**
 * The module that includes http's providers
 *
 * @experimental
 */
var BhtpRulesServiceModule = (function () {
    function BhtpRulesServiceModule() {
    }
    return BhtpRulesServiceModule;
}());
BhtpRulesServiceModule = __decorate([
    core_1.NgModule({
        providers: [
            // TODO(pascal): use factory type annotations once supported in DI
            // issue: https://github.com/angular/angular/issues/3183
            { provide: rules_service_1.BhtpRulesService, useFactory: bhtpRulesServiceFactory, deps: [http_1.Http] },
        ],
    })
], BhtpRulesServiceModule);
exports.BhtpRulesServiceModule = BhtpRulesServiceModule;
//# sourceMappingURL=D:/a/1/s/eligibility/src/rules.module.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/rules.module.js